<template>
<div class="chapter">
<div class="inner_page">
<p class="Basic-Paragraph para-style-override-4"></p>
<p class="Basic-Paragraph para-style-override-2"></p>
<p class="Basic-Paragraph para-style-override-11"></p>
<p class="x-1-Chapter-number"></p>
<p class="x-2-chapter-title">Contents</p>
<p class="Basic-Paragraph para-style-override-11"></p>
<table>
<tbody><tr>
<td></td>
<td>                      <a href="#/Text/Introduction">Introduction</a><br/></td>
</tr>
<tr>
<td> </td>
<td>                      <a href="#/Text/SCRPp1">Chapter One     “</a><a href="#/Text/SCRPp1">[They] Had Set Their Hearts Upon the Southern Cross”</a><br/></td>
</tr>
<tr>
<td><br/></td>
<td>                      <span href="#/Text/SCRPp2" title="Link target outside of Sample">Chapter Two     </span><span href="#/Text/SCRPp2" title="Link target outside of Sample">“It Was Soon, However, Discovered to Be a Regiment of the Enemy”</span><br/></td>
</tr>
<tr>
<td><br/></td>
<td>                      <span href="#/Text/SCRPp3" title="Link target outside of Sample">Chapter Three  “</span><span href="#/Text/SCRPp3" title="Link target outside of Sample">It Was an Army Affair . . . I Have Always Said So”</span><br/></td>
</tr>
<tr>
<td><br/></td>
<td>                      <span href="#/Text/SCRPp4" title="Link target outside of Sample">Chapter Four    “</span><span href="#/Text/SCRPp4" title="Link target outside of Sample">[I] First Solicited the Assistance of Mrs. James Alfred Jones”</span><br/></td>
</tr>
<tr>
<td><br/></td>
<td>                      <span href="#/Text/SCRPp5" title="Link target outside of Sample">Chapter Five    “</span><span href="#/Text/SCRPp5" title="Link target outside of Sample">Your Mothers, Your Wives and Your Sisters Have Made It”</span><br/></td>
</tr>
<tr>
<td><br/></td>
<td>                      <span href="#/Text/SCRPp6" title="Link target outside of Sample">Chapter Six      </span><span href="#/Text/SCRPp6" title="Link target outside of Sample">“Gayety Was the Most Marked Feature about Them”</span><br/></td>
</tr>
<tr>
<td><br/></td>
<td>                     <span href="#/Text/SCRPp7" title="Link target outside of Sample">Chapter Seven “</span><span href="#/Text/SCRPp7" title="Link target outside of Sample">[I] Recommend That They. . . Have ‘Perryville’ Inscribed on Their Banner”</span><br/></td>
</tr>
<tr>
<td></td>
<td>                     <span href="#/Text/Epilogue" title="Link target outside of Sample">Epilogue</span><br/></td>
</tr>
<tr>
<td></td>
<td>                     <span href="#/Text/Abbreviations" title="Link target outside of Sample">Abbreviations</span></td>
</tr>
<tr>
<td><br/></td>
<td>                     <span href="#/Text/ColorAppendix" title="Link target outside of Sample">Photographic Appendix</span></td>
</tr>
<tr>
<td></td>
<td>                     <span href="#/Text/Notes" title="Link target outside of Sample">Notes</span><br/></td>
</tr>
<tr>
<td><br/></td>
<td>                     <span href="#/Text/Bibliography" title="Link target outside of Sample">Bibliography</span><br/></td>
</tr>
</tbody></table>
<div>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph para-style-override-11"></p>
<p class="x-1-Chapter-number"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ToC.vue?17e0c761